module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/drums-and-percussion-ce20c77c169a936124b4445df1763f9b.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/drums-and-percussion.png
// module id = blG6
// module chunks = 9 11 12